import { useContext } from '@nuxtjs/composition-api'
import queryString from 'query-string'
import { BRAND_MEDIA_LEADER } from '../../../../config/bitrix-endpoints'
import { BITRIX_API } from '../../instance'

export async function getLeader(
  ctx: ReturnType<useContext> | undefined = undefined,
  section: string | undefined = undefined,
  limit: number,
  currArticle: number,
  order?: boolean
) {
  const q = { section }
  if (limit) {
    q.limit = limit
    q.curr_article_id = currArticle
  }
  if (order) q.order = 1
  let qs = queryString.stringify(q)
  if (qs) qs = '?' + qs
  return await BITRIX_API(ctx).get(BRAND_MEDIA_LEADER + qs)
}
